import { RequestConfig } from '@/interface'

const PREFIX = '/fpgl/jcskRpa/'

const rpaConfig: RequestConfig = {
  // 新增或修改纳税人登录信息
  rpaAddOrUpdate: {
    url: `${PREFIX}addOrUpdate`,
    method: 'get'
  },
  // 二维码
  rpaErweima: {
    url: `${PREFIX}erweima`,
    method: 'get'
  },
  // 获取验证码
  rpaLogin: {
    url: `${PREFIX}login`,
    method: 'get'
  },
  // 获取登录状态
  rpaLoginStatus: {
    url: `${PREFIX}loginStatus`,
    method: 'get'
  },
  // 获取扫脸结果
  rpaSmjg: {
    url: `${PREFIX}smjg`,
    method: 'get'
  },
  // 提交验证码
  rpaSubmitCode: {
    url: `${PREFIX}submitCode`,
    method: 'get'
  }
}
export default rpaConfig
